import React, { Component } from 'react';
export function Navbar() {
  return <nav className="fixed top-9 w-full z-50 bg-white/80 backdrop-blur-md border-b border-slate-200 shadow-sm" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="flex justify-between items-center h-20" data-id="element-106">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/nzP439yEmSh8C63o3zF755/logo.jpg" alt="FG Divisas" className="w-11 h-11 rounded-full object-cover border border-slate-200" data-id="element-108" />
            <span className="text-[#0a2540] font-bold text-xl tracking-tight" data-id="element-109">
              FG Divisas
            </span>
          </div>

          {/* Right CTA */}
          <div className="flex items-center" data-id="element-110">
            <button onClick={() => {
            const text = 'Hola, tengo aproximadamente USD y quisiera cotizar estos billetes. Adjunto fotos.';
            window.open(`https://wa.me/5491176110902?text=${encodeURIComponent(text)}`, '_blank');
          }} className="group relative inline-flex items-center justify-center px-6 py-2.5 text-sm font-semibold text-white transition-all duration-200 bg-[#0a2540] border border-[#0a2540] rounded-full hover:bg-[#1a365d] hover:border-[#1a365d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0a2540] focus:ring-offset-white" data-id="element-111">
              <span className="relative flex h-2 w-2 mr-2" data-id="element-112">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-113"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-114"></span>
              </span>
              Ver Cotización
            </button>
          </div>
        </div>
      </div>
    </nav>;
}